export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";